import type { AfterContentInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  QueryList,
} from '@angular/core';
import { FontColor, TextTransform } from '@freelancer/ui/text';
import type { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { BreadcrumbsItemComponent } from './breadcrumbs-item.component';

@Component({
  standalone: true,
  selector: 'fl-breadcrumbs',
  template: `
    <div
      role="list"
      class="Breadcrumbs"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(BreadcrumbsItemComponent)
  breadcrumbsItems: QueryList<BreadcrumbsItemComponent>;

  private itemsSubscription?: Subscription;

  @Input() color = FontColor.FOREGROUND;
  @Input() textTransform = TextTransform.UPPERCASE;

  ngAfterContentInit(): void {
    this.itemsSubscription = this.breadcrumbsItems.changes
      .pipe(startWith(this.breadcrumbsItems.toArray()))
      .subscribe(() => {
        this.breadcrumbsItems.forEach((component, index) => {
          component.position = index + 1;
          // T255421: Using detectChanges() since markForCheck() leads to an undefined position in the ssr page.
          component.color = this.color;
          component.textTransform = this.textTransform;
          component.changeDetector.detectChanges();
        });
      });
  }

  ngOnDestroy(): void {
    if (this.itemsSubscription) {
      this.itemsSubscription.unsubscribe();
    }
  }
}
